// src/app/forgot.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../apiConfig.js';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleForgotPassword = async () => {
    if (!email) {
      alert('Please enter your email address.');
      return;
    }

    try {
      setLoading(true);
      
      const response = await axios.post(`${API_BASE_URL}/forgot-password`, {
        email: email
      });

      if (response.data.success) {
        alert(`Password Reset Sent\n\nIf your email is associated with an account, you will receive a password reset link shortly. Please check your email and follow the instructions to reset your password.`);
        navigate('/login');
      } else {
        alert('Failed to send password reset email. Please try again.');
      }
    } catch (error) {
      console.error('Error requesting password reset:', error);
      
      let errorMessage = 'Failed to send password reset email. Please try again.';
      
      if (error.response?.data?.detail) {
        errorMessage = error.response.data.detail;
      } else if (error.response?.status === 400) {
        errorMessage = 'Please check your email address and try again.';
      } else if (error.response?.status === 500) {
        errorMessage = 'Server error. Please try again later.';
      }
      
      alert(`Error: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.header}>Reset Password</h1>
      <p style={styles.instructions}>
        Enter your email address and we'll send you a link to reset your password.
      </p>
      
      <input
        type="email"
        style={styles.input}
        placeholder="Enter Email Address"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        autoComplete="email"
      />
      
      <button 
        style={loading ? { ...styles.button, ...styles.buttonDisabled } : styles.button}
        onClick={handleForgotPassword}
        disabled={loading}
      >
        {loading ? 'Sending...' : 'Send Reset Link'}
      </button>
      
      <button 
        style={styles.linkButton}
        onClick={() => navigate('/login')}
      >
        Back to Login
      </button>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    padding: '20px',
    backgroundColor: '#f8f9fa',
  },
  header: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '10px',
    textAlign: 'center',
  },
  instructions: {
    fontSize: '16px',
    color: '#666',
    textAlign: 'center',
    marginBottom: '30px',
    lineHeight: '1.4',
    maxWidth: '400px',
  },
  input: {
    width: '300px',
    padding: '12px',
    marginBottom: '20px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    fontSize: '16px',
    outline: 'none',
  },
  button: {
    width: '200px',
    backgroundColor: '#007AFF',
    color: 'white',
    padding: '12px',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginBottom: '15px',
  },
  buttonDisabled: {
    backgroundColor: '#ccc',
    cursor: 'not-allowed',
  },
  linkButton: {
    background: 'none',
    border: 'none',
    color: '#007AFF',
    fontSize: '16px',
    textDecoration: 'underline',
    cursor: 'pointer',
    marginTop: '10px',
  },
};
